// extracted by mini-css-extract-plugin
export default {"layout":"App_layout__Asyut"};